import {DateTime} from 'luxon';

import {generateFetchOptions} from '../index';

import {TERMS_OF_SERVICE} from '../../../constants';

// POST /api/v1/oauth/linkedin/signup/callback
export async function signupCallback(provider: string, authorizationCode: string, state: string): Promise<Response> {
  const currentDateTime = DateTime.local();
  const timezone = currentDateTime.zoneName;

  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/users/oauth/${provider}/signup/callback`,
    generateFetchOptions({
      method: 'POST',
      isProtected: false,
      body: {
        authorization_code: authorizationCode,
        state,
        timezone: timezone as string,
        terms_of_service: {
          accept: true,
          version: TERMS_OF_SERVICE,
        },
        role: 'applicant',
      },
    })
  );
}
